import { render, staticRenderFns } from "./BroomxView.vue?vue&type=template&id=e94e9120"
import script from "./BroomxView.vue?vue&type=script&lang=js"
export * from "./BroomxView.vue?vue&type=script&lang=js"
import style0 from "./BroomxView.vue?vue&type=style&index=0&id=e94e9120&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports